import { render, staticRenderFns } from "./DashboardPricing.vue?vue&type=template&id=0781a106&scoped=true&"
import script from "./DashboardPricing.vue?vue&type=script&lang=js&"
export * from "./DashboardPricing.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPricing.vue?vue&type=style&index=0&id=0781a106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0781a106",
  null
  
)

export default component.exports